import React, {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';

const DepositNotFound = (): ReactElement => {
  const {t} = useTranslation();
  return <div className="ofelos-pay-title"><h1>{t('error_322')}</h1></div>;
};

export default DepositNotFound;
